import { PRODUCT_DATA } from "@/polymet/data/product-data";
import {
  SUSTAINABILITY_DATA,
  MARKET_COMPARISON_DATA,
} from "@/polymet/data/sustainability-data";
import ProductHeader from "@/polymet/components/product-header";
import ProductTitleBanner from "@/polymet/components/product-title-banner";
import MarketOpportunityCard from "@/polymet/components/market-opportunity-card";
import ConsumerFeedbackTable from "@/polymet/components/consumer-feedback-table";
import FormulationTable from "@/polymet/components/formulation-table";
import MarketInfoCard from "@/polymet/components/market-info-card";
import SupplyAvailabilityTable from "@/polymet/components/supply-availability-table";
import EnhancedProcessingStepsCard from "@/polymet/components/enhanced-processing-steps-card";
import SustainabilityMetricsCard from "@/polymet/components/sustainability-metrics-card";
import MarketComparisonCard from "@/polymet/components/market-comparison-card";

export default function EnhancedProductDashboard() {
  const {
    productName,
    productImage,
    marketOpportunity,
    consumerFeedback,
    formulation,
    marketInformation,
    supplyAvailability,
    processingSteps,
  } = PRODUCT_DATA;

  const { co2Reduction, waterSaved, wasteReduction } = SUSTAINABILITY_DATA;

  return (
    <div className="min-h-screen bg-slate-50">
      <ProductHeader />

      <div className="container mx-auto p-4 max-h-[calc(100vh-76px)] overflow-auto">
        <div className="grid grid-cols-12 gap-4">
          {/* Product Image and Market Info */}
          <div className="col-span-12 md:col-span-3 flex flex-col gap-4">
            <div className="bg-amber-50 rounded-lg p-4 flex justify-center items-center">
              <img
                src={productImage}
                alt={productName}
                className="max-h-[240px] object-contain"
              />
            </div>
            <div className="flex-grow">
              <MarketInfoCard marketInfoItems={marketInformation} />
            </div>
            <div className="flex-grow">
              <SustainabilityMetricsCard
                co2Reduction={co2Reduction}
                waterSaved={waterSaved}
                wasteReduction={wasteReduction}
              />
            </div>
          </div>

          {/* Main Content */}
          <div className="col-span-12 md:col-span-9 flex flex-col gap-4">
            <ProductTitleBanner productName={productName} />

            <div className="grid grid-cols-12 gap-4">
              {/* Market Opportunity */}
              <div className="col-span-12 md:col-span-5">
                <MarketOpportunityCard
                  costReduction={marketOpportunity.costReduction}
                  marketValue={marketOpportunity.marketValue}
                />
              </div>

              {/* Consumer Feedback */}
              <div className="col-span-12 md:col-span-7">
                <ConsumerFeedbackTable feedbackItems={consumerFeedback} />
              </div>
            </div>

            {/* Formulation */}
            <div className="w-full">
              <FormulationTable
                originalIngredients={formulation.originalIngredients}
                replacementIngredients={formulation.replacementIngredients}
                functionalImprovements={formulation.functionalImprovements}
                nutritionalImprovements={formulation.nutritionalImprovements}
              />
            </div>

            <div className="grid grid-cols-12 gap-4">
              {/* Supply Availability */}
              <div className="col-span-12 md:col-span-7">
                <SupplyAvailabilityTable
                  byproduct={supplyAvailability.byproduct}
                  volume={supplyAvailability.volume}
                  productVolume={supplyAvailability.productVolume}
                  suppliers={supplyAvailability.suppliers}
                />
              </div>

              {/* Processing Steps */}
              <div className="col-span-12 md:col-span-5">
                <EnhancedProcessingStepsCard steps={processingSteps} />
              </div>
            </div>

            {/* Market Comparison */}
            <div className="w-full">
              <MarketComparisonCard competitors={MARKET_COMPARISON_DATA} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
